import React from 'react';
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min';
import TaskCard from '../TaskCard';
import styled from 'styled-components';

function TaskCardContainer(props) {
  const {
    allTasks,
    exemplar,
    setPublishActionCompleted,
    showDeletePopuphandler,
    showClosePopupHandler,
    showDateExtendPopuphandler,
    assignmentIdForDuplicate,
    showSchedulePublishPopupHandler,
    showAssignmentStatusPopupHandler,
    onUploadResponses,
    classData,
  } = props;
  const location = useLocation();

  const cards = allTasks.map((task) => {
    const link = location.pathname.includes('classes') ? null : task.link;
    return (
      // The student /tasks API returns one row per (class, task) pair, so a
      // task set for two of the student's classes repeats its id. Keying on
      // the id alone made React keep stale cards around when a filter changed
      // the list (JED-1290).
      <CardLink key={`${task.id}:${task.classId ?? ''}`}>
        <TaskCard
          task={task}
          exemplar={exemplar}
          classData={classData}
          setPublishActionCompleted={setPublishActionCompleted}
          showDeletePopuphandler={showDeletePopuphandler}
          showClosePopupHandler={showClosePopupHandler}
          showDateExtendPopuphandler={showDateExtendPopuphandler}
          assignmentIdForDuplicate={assignmentIdForDuplicate}
          showSchedulePublishPopupHandler={showSchedulePublishPopupHandler}
          showAssignmentStatusPopupHandler={showAssignmentStatusPopupHandler}
          onUploadResponses={onUploadResponses}
        />
      </CardLink>
    );
  });
  return exemplar ? (
    <ExemplerCardContainer>{cards}</ExemplerCardContainer>
  ) : (
    <CardContainer>{cards}</CardContainer>
  );
}

const CardLink = styled.div`
  display: block;
  width: 100%;
  min-width: 0;
  max-width: 100%;
  text-decoration: none;
  color: inherit;
`;

const CardContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  align-items: stretch;
  gap: 11px;
  padding: 0px 0px 10px 0px;
  overflow-y: scroll;
  overflow-x: hidden;
  min-width: 0;
  &::-webkit-scrollbar {
    width: 0;
    display: none;
  }
  @media (max-width: 1024px) {
    max-height: 480px;
  }
  padding: 20px;
`;
const ExemplerCardContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex-direction: column;
  width: 100%;
  align-items: center;
  gap: 20px;
  padding: 0px 0px 10px 0px;
`;
export default TaskCardContainer;
